import React from "react";

export function Choice() {
  return (
    <svg
      width="82"
      height="100"
      viewBox="0 0 82 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="choices 1">
        <g id="Group">
          <g id="Group_2">
            <path
              id="Vector"
              d="M21.7934 20.0418C20.9287 20.0418 20.2276 20.7428 20.2276 21.6076C20.2276 23.507 18.6823 25.0523 16.7828 25.0523C14.8834 25.0523 13.3381 23.507 13.3381 21.6076C13.3381 19.7082 14.8834 18.1629 16.7828 18.1629C17.6475 18.1629 18.3487 17.4619 18.3487 16.5971C18.3487 15.7322 17.6477 15.0312 16.7828 15.0312C13.1567 15.0312 10.2067 17.9814 10.2067 21.6074C10.2067 25.2334 13.1569 28.1836 16.7828 28.1836C20.4088 28.1836 23.359 25.2334 23.359 21.6074C23.3592 20.7428 22.658 20.0418 21.7934 20.0418Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_3">
          <g id="Group_4">
            <path
              id="Vector_2"
              d="M21.7934 38.4133C20.9287 38.4133 20.2276 39.1143 20.2276 39.9791C20.2276 41.8785 18.6823 43.4238 16.7828 43.4238C14.8834 43.4238 13.3381 41.8785 13.3381 39.9791C13.3381 38.0797 14.8834 36.5344 16.7828 36.5344C17.6475 36.5344 18.3487 35.8334 18.3487 34.9686C18.3487 34.1037 17.6477 33.4027 16.7828 33.4027C13.1567 33.4027 10.2067 36.3529 10.2067 39.9789C10.2067 43.6049 13.1569 46.5551 16.7828 46.5551C20.4088 46.5551 23.359 43.6049 23.359 39.9789C23.3592 39.1145 22.658 38.4133 21.7934 38.4133Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_5">
          <g id="Group_6">
            <path
              id="Vector_3"
              d="M40.1648 41.7537H28.4738C27.6091 41.7537 26.908 42.4547 26.908 43.3195C26.908 44.1844 27.6089 44.8854 28.4738 44.8854H40.1648C41.0294 44.8854 41.7306 44.1844 41.7306 43.3195C41.7306 42.4547 41.0296 41.7537 40.1648 41.7537Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_7">
          <g id="Group_8">
            <path
              id="Vector_4"
              d="M40.1648 35.0731H28.4738C27.6091 35.0731 26.908 35.774 26.908 36.6389C26.908 37.5037 27.6089 38.2047 28.4738 38.2047H40.1648C41.0294 38.2047 41.7306 37.5037 41.7306 36.6389C41.7306 35.774 41.0296 35.0731 40.1648 35.0731Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_9">
          <g id="Group_10">
            <path
              id="Vector_5"
              d="M36.8246 60.1252H28.4738C27.6091 60.1252 26.908 60.8262 26.908 61.691C26.908 62.5559 27.6089 63.2568 28.4738 63.2568H36.8246C37.6892 63.2568 38.3904 62.5559 38.3904 61.691C38.3904 60.8262 37.6892 60.1252 36.8246 60.1252Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_11">
          <g id="Group_12">
            <path
              id="Vector_6"
              d="M40.1648 53.4447H28.4738C27.6091 53.4447 26.908 54.1457 26.908 55.0106C26.908 55.8754 27.6089 56.5764 28.4738 56.5764H40.1648C41.0294 56.5764 41.7306 55.8754 41.7306 55.0106C41.7306 54.1457 41.0296 53.4447 40.1648 53.4447Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_13">
          <g id="Group_14">
            <path
              id="Vector_7"
              d="M55.1962 23.382H28.4738C27.6091 23.382 26.908 24.083 26.908 24.9479C26.908 25.8127 27.6089 26.5137 28.4738 26.5137H55.196C56.0607 26.5137 56.7619 25.8127 56.7619 24.9479C56.7619 24.083 56.0609 23.382 55.1962 23.382Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_15">
          <g id="Group_16">
            <path
              id="Vector_8"
              d="M48.5156 16.7014H28.4738C27.6091 16.7014 26.908 17.4023 26.908 18.2672C26.908 19.132 27.6089 19.833 28.4738 19.833H48.5156C49.3802 19.833 50.0814 19.132 50.0814 18.2672C50.0814 17.4023 49.3804 16.7014 48.5156 16.7014Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_17">
          <g id="Group_18">
            <path
              id="Vector_9"
              d="M21.7934 56.785C20.9287 56.785 20.2276 57.4859 20.2276 58.3508C20.2276 60.2502 18.6823 61.7955 16.7828 61.7955C14.8834 61.7955 13.3381 60.2502 13.3381 58.3508C13.3381 56.4514 14.8834 54.9061 16.7828 54.9061C17.6475 54.9061 18.3487 54.2051 18.3487 53.3402C18.3487 52.4754 17.6477 51.7744 16.7828 51.7744C13.1567 51.7744 10.2067 54.7246 10.2067 58.3506C10.2067 61.9766 13.1569 64.9268 16.7828 64.9268C20.4088 64.9268 23.359 61.9766 23.359 58.3506C23.3592 57.4859 22.658 56.785 21.7934 56.785Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_19">
          <g id="Group_20">
            <path
              id="Vector_10"
              d="M61.8768 0H5.09185C2.38677 0 0.185791 2.20078 0.185791 4.90605V75.0521C0.185791 77.7574 2.38657 79.9582 5.09185 79.9582H33.4844C34.3491 79.9582 35.0502 79.2572 35.0502 78.3924C35.0502 77.5277 34.3493 76.8266 33.4844 76.8266H5.09185C4.11333 76.8266 3.31724 76.0305 3.31724 75.0519V4.90605C3.31724 3.92754 4.11333 3.13145 5.09185 3.13145H61.8768C62.8553 3.13145 63.6514 3.92754 63.6514 4.90605V56.6809C63.6514 57.5455 64.3524 58.2467 65.2172 58.2467C66.0819 58.2467 66.7831 57.5457 66.7831 56.6809V4.90605C66.7829 2.20078 64.5821 0 61.8768 0Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_21">
          <g id="Group_22">
            <path
              id="Vector_11"
              d="M76.6597 63.4949C75.2044 63.3498 73.7499 63.7623 72.5988 64.6363C71.6818 63.0977 70.1181 62.0061 68.3089 61.8248C66.8533 61.6799 65.399 62.0924 64.248 62.9662C63.331 61.4275 61.7673 60.3359 59.9581 60.1547C58.8468 60.0438 57.737 60.2578 56.7619 60.7541V40.8143C56.7619 39.1953 56.0732 37.6434 54.8718 36.5564C53.6716 35.4705 52.0542 34.9404 50.4341 35.1025C47.5437 35.392 45.2796 38.0055 45.2796 41.0525V61.0428L40.6769 65.6455C38.231 68.0914 37.2437 71.5617 38.0361 74.9289L41.5304 89.7799C42.9462 95.7977 48.2527 100 54.4347 100H68.5572C75.8669 100 81.814 94.0535 81.814 86.7436V69.4453C81.8142 66.3979 79.5501 63.7844 76.6597 63.4949ZM78.6826 86.7432C78.6826 92.3262 74.1404 96.8684 68.5574 96.8684H54.4349C49.7132 96.8684 45.6601 93.6584 44.5787 89.0621L41.0843 74.2111C40.5421 71.9074 41.2177 69.5328 42.8912 67.8594L45.2796 65.4709V70.8768C45.2796 71.7414 45.9806 72.4426 46.8454 72.4426C47.7103 72.4426 48.4113 71.7416 48.4113 70.8768V41.0523C48.4113 39.5943 49.4369 38.3494 50.7464 38.2185C51.4986 38.143 52.2179 38.3777 52.771 38.8785C53.3173 39.3728 53.6306 40.0785 53.6306 40.8144V68.3719C53.6306 69.2365 54.3316 69.9377 55.1964 69.9377C56.0613 69.9377 56.7622 69.2367 56.7622 68.3719V65.8666C56.7622 65.1307 57.0753 64.425 57.6218 63.9307C58.1753 63.4299 58.8943 63.1949 59.6464 63.2707C60.9558 63.4018 61.9816 64.6467 61.9816 66.1047V70.0416C61.9816 70.9063 62.6826 71.6074 63.5474 71.6074C64.4121 71.6074 65.1132 70.9064 65.1132 70.0416V67.5363C65.1132 66.8004 65.4263 66.0947 65.9728 65.6004C66.5263 65.0996 67.2454 64.8648 67.9974 64.9404C69.3068 65.0715 70.3326 66.3164 70.3326 67.7744V71.7115C70.3326 72.5762 71.0335 73.2773 71.8984 73.2773C72.763 73.2773 73.4642 72.5764 73.4642 71.7115V69.2063C73.4642 68.4703 73.7773 67.7647 74.3238 67.2703C74.8773 66.7697 75.5958 66.5346 76.3484 66.6105C77.6578 66.7414 78.6835 67.9863 78.6835 69.4443V86.7432H78.6826Z"
              fill="#242424"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
